import styled from 'styled-components';

import { mediaConfined } from '@xing-com/layout-tokens';
import {
  scale080,
  scale090,
  scale100,
  scale150,
  spaceXS,
  spaceS,
  spaceM,
  spaceXL,
  spaceXXL,
  space3XL,
  space4XL,
  xdlColorBackground,
} from '@xing-com/tokens';
import { BodyCopy } from '@xing-com/typography';

export const Card = styled.div`
  align-items: center;
  background-color: ${xdlColorBackground};
  border-radius: ${scale080};
  display: flex;
  flex-direction: column;
  padding: ${spaceXXL} ${scale100};

  &:not(:last-child) {
    margin-bottom: ${spaceXL};
  }

  @media ${mediaConfined} {
    flex-direction: row;
    padding: ${scale150} ${space3XL};

    &:not(:last-child) {
      margin-bottom: 0;
    }
  }
`;

export const Image = styled.img`
  border-radius: ${spaceXS};
  height: 90px;
  margin-bottom: ${spaceXL};
  width: 160px;

  @media ${mediaConfined} {
    height: 104px;
    margin: 0 ${spaceXL} 0 0;
    width: 185px;
  }
`;

export const DesktopContainer = styled.div`
  text-align: center;

  @media ${mediaConfined} {
    text-align: left;
  }
`;

export const Link = styled.a`
  font-size: ${scale090};
  line-height: 29px;
  text-align: center;
  text-decoration: underline;

  @media ${mediaConfined} {
    text-align: left;
  }
`;

export const OuterWrapper = styled.div`
  @media ${mediaConfined} {
    align-items: center;
    display: flex;

    & > a {
      margin-left: ${spaceS};
    }
  }
`;

export const ReadingTimeWrapper = styled.span`
  display: flex;
  justify-content: center;
  margin: ${space4XL} 0 ${spaceM};

  @media ${mediaConfined} {
    margin-top: ${spaceM};
  }
`;

export const ReadingTime = styled(BodyCopy)`
  margin: 0 0 0 ${spaceS};
`;
